export default __webpack_public_path__ + "static/media/loading-4.71e5d0eb.jpeg";